import { styled } from '@mui/material';

const StyledLinkButton = styled('button')(({ theme }) => ({
  backgroundColor: 'transparent',
  border: 'none',
  cursor: 'pointer',
  textTransform: 'initial',
  font: 'inherit',
  fontSize: 'inherit',
  display: 'inline',
  margin: 0,
  padding: 0,
  color: theme.palette.primary.main,
}));

export const LinkButton = (props: React.ComponentProps<typeof StyledLinkButton>) => (
  <StyledLinkButton type="button" {...props} />
);
